import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Lightbox from '../../Lightbox'
import { CloudinaryS3Image } from '../../CloudinaryS3Image'

import CloseIcon from './icons/CloseIcon'
import LeftArrow from './icons/LeftArrow'
import RighttArrow from './icons/RighttArrow'
import {
  GallerySection,
  GalleryHeader,
  GalleryBody,
  GalleryFooter,
  GalleryCloseIconContainer,
  GalleryFooterDescription,
  GalleryFooterDate,
  GalleryFooterHorizontalLine,
  GalleryNavigationContainerRight,
  GalleryNavigationContainerLeft
} from './styledComponents'

class GalleryHome extends Component {
  state = {
    activeNodeId: 0
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeydown, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeydown, false)
  }

  onKeydown = e => {
    const { totalImagesData } = this.props

    if (e.keyCode === 39) {
      if (this.state.activeNodeId < totalImagesData.length - 1) {
        this.gotoNext()
      }
    } else if (e.keyCode === 37) {
      if (this.state.activeNodeId > 0) {
        this.gotoPrevious()
      }
    } else if (e.keyCode === 27) {
      this.props.closeLightBox()
    }
  }

  componentWillMount() {
    this.setState({ activeNodeId: this.props.currentImageData.imageId })
  }
  gotoPrevious = () => {
    let previousIndex = parseInt(this.state.activeNodeId) - 1
    if (previousIndex < 0) {
      previousIndex = 0
    }
    this.setState({
      activeNodeId: previousIndex
    })
  }
  gotoNext = () => {
    const { totalImagesData } = this.props
    let nextIndex = parseInt(this.state.activeNodeId) + 1
    if (nextIndex === totalImagesData.length) {
      nextIndex = 0
    }
    this.setState({
      activeNodeId: nextIndex
    })
  }

  isMobileDevice = () => {
    let isMobile = true
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (window.innerWidth > 767) {
        isMobile = false
      }
    }
    return isMobile
  }

  render() {
    const { totalImagesData, closeLightBox, date } = this.props
    const { activeNodeId } = this.state
    const { shortDescription, imageUrl } = totalImagesData[activeNodeId]

    const isMobile = this.isMobileDevice()
    const maxLength = totalImagesData.length
    return (
      <div>
        <Lightbox isOpen={this.props.isLightBoxOpen}>
          <GallerySection>
            <GalleryHeader>
              {activeNodeId > 0 ? (
                <GalleryNavigationContainerLeft onClick={this.gotoPrevious}>
                  <LeftArrow width="18" height="12" fillColor="#FFF" />
                </GalleryNavigationContainerLeft>
              ) : null}

              {activeNodeId < maxLength - 1 ? (
                <GalleryNavigationContainerRight onClick={this.gotoNext}>
                  <RighttArrow width="18" height="12" fillColor="#FFF" />
                </GalleryNavigationContainerRight>
              ) : null}

              <GalleryCloseIconContainer onClick={closeLightBox}>
                <CloseIcon width="14" height="14" fillColor="#FFF" />
              </GalleryCloseIconContainer>
            </GalleryHeader>
            <GalleryBody>
              {' '}
              <article
                className="6u 12u$(xsmall) work-item"
                style={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <CloudinaryS3Image
                  configString={'f_auto'}
                  src={imageUrl}
                  style={{
                    height: `50vh`,
                    maxWidth: `80%`,
                    objectFit: `contain`,
                    draggable: `false`,
                    marginTop: isMobile ? 0 : '50px'
                  }}
                />
              </article>{' '}
            </GalleryBody>
            <GalleryFooter>
              <GalleryFooterDescription>
                {shortDescription}
              </GalleryFooterDescription>
              <GalleryFooterDate>{date}</GalleryFooterDate>
              <GalleryFooterHorizontalLine />
            </GalleryFooter>
          </GallerySection>
        </Lightbox>
      </div>
    )
  }
}

GalleryHome.displayName = 'Gallery'
GalleryHome.propTypes = {
  totalImagesData: PropTypes.array
}

export default GalleryHome



// WEBPACK FOOTER //
// ./src/components/Home/GalleryHome/index.js